import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { auraGames } from "../../lib/data/auraGames.data";
import CasinoCard from "./CasinoCard";

const RightBarCasino = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    { name: "Improved Experience", key: "improvedExperience" },
    { name: "Card Games", key: "cardGames" },
    { name: "Virtual Card Games", key: "virtualCardGames" },
    { name: "Instant Games", key: "instantGames" },
  ];
  const [activeCategory, setActiveCategory] = useState("improvedExperience");
  const { isAuth } = useSelector((state) => state.auth);
  const [filteredData, setFilteredData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  return (
    <>
      <div className="rightbarSec">
        <h6>AURA GAMES</h6>
        <ul className="tabs">
          {categoriesTab.map((tab, index) => (
            <li
              key={index}
              onClick={() => {
                setFilteredData([]);
                setIsSearched(false);
                if (tab?.redirectUrl) {
                  navigate(tab?.redirectUrl);
                } else {
                  setActiveCategory(tab.key);
                }
              }}
            >
              <a
                href="javascript:void(0)"
                style={
                  activeCategory === tab.key
                    ? {
                        background: "#c62f4a",
                        color: "#ffffff",
                      }
                    : {}
                }
              >
                {tab.name}
              </a>
            </li>
          ))}
        </ul>

        {!isSearched ? (
          <ul className="games">
            {Array.isArray(Object.values(auraGames)) &&
              Object.values(auraGames)
                .filter((f) => f?.key === activeCategory)
                .map((slide) =>
                  Object.values(slide)
                    .filter((f) => typeof f !== "string")
                    .map((game) =>
                      Object.values(game).map((item, idx) => (
                        <CasinoCard key={"casinogame" + idx} data={item} />
                      ))
                    )
                )}
          </ul>
        ) : (
          <ul className="games">
            {(filteredData.length &&
              filteredData.map((game, idx) => (
                <CasinoCard key={"casinogame" + idx} data={game} />
              ))) ||
              null}
          </ul>
        )}
      </div>
    </>
  );
};

export default RightBarCasino;
